// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"da8b67fd","645":"4f37873e"}[chunkId] + ".chunk.css";
};